/**
 * Types of Program restrictions.
 */
export enum MKProgramRestrictionType {
    /**
     * Rewind is not allowed.
     * 
     */
    Rewind = "rewind",

    /**
     * Fast forward is not allowed.
     * 
     */
    FastForward = "fastforward",

    /**
     * Pause is not allowed.
     * 
     */
    Pause = "pause",

    /**
     * Resume is not allowed.
     * 
     */
    Resume = "resume",

    /**
     * Seek forward is not allowed.
     * 
     */
    SeekForward = "seekforward",

    /**
     * Seek backward is not allowed.
     * 
     */
    SeekBackward = "seekbackward",

    /**
     * Restart is not allowed.
     * 
     */
    Restart = "restart",

    /**
     * Timeshift is not allowed.
     * 
     */
    Timeshift = "timeshift",

    /**
     * Seek skip is not allowed.
     * 
     */
    SeekSkip= "seekskip",

    /**
     * CatchUp is allowed.
     * 
     */
    CatchUp = "catchup",

    /**
     * Android is not allowed.
     * 
     */
    AndroidBlocked = "androidblocked",

    /**
     * IOS is not allowed.
     * 
     */
    IOSBlocked = "iosblocked",

    /**
     * Phone is not allowed.
     * 
     */
    PhoneBlocked = "phoneblocked",

    /**
     * Tablet is not allowed.
     * 
     */
    TabletBlocked = "tabletblocked",

    /**
     * DesktopBlocked is not allowed.
     * 
     */
    DesktopBlocked = "desktopblocked",

    /**
     * Outofhome is not allowed.
     * 
     */
    OutofhomeBlocked = "outofhomeblocked",

    /**
     * AirplayBlocked is not allowed.
     * 
     */
    AirplayBlocked = "airplayblocked",

    //commenting the below two cases as it is currently not supported on this platform
    /**
     * CellularBlocked is not allowed.
     * 
     */
    //CellularBlocked = "cellularblocked",

    /**
     * WifiBlocked is not allowed.
     * 
     */
    //WifiBlocked = "wifiblocked",
}